module.exports = __webpack_public_path__ + "img/ic-right.5134ee43.svg";